import React from 'react';

class DeviceRegistrationView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        /*DevicesService.getDeviceTypes().then(response => {
            console.log(response);
            this.setState({
                deviceTypeOptions: response.deviceTypes.map(deviceType => ({value: deviceType.id, label: `${deviceType.name} (${deviceType.deviceFunctionalType.name})`, deviceType: deviceType}))
            });
        }).catch((err) => {
            console.error(err);
        });*/
    }

    
    render() {
        return (<div>TODO</div>);
    }
}

export default DeviceRegistrationView;